import { Breadcrumb } from 'antd';
import { NavLink } from 'react-router-dom';
import './style.css';

export const Breadcrumbs = ({ breadcrumbs }) => {
  const isStringNotEmpty = (value) => Object.prototype.toString.call(value) === '[object String]' && value !== '';
  return (
    <Breadcrumb separator='>' style={{ marginBottom: '15px' }}>
      {breadcrumbs.map((value, index) => {
        return (
          <Breadcrumb.Item style={{ color: '#000000', fontWeight: '600' }} key={index}>
            {isStringNotEmpty(value.href) ? (
              <NavLink to={{ pathname: value?.href }} state={value?.data || null}>
                {value?.name}
              </NavLink>
            ) : (
              value?.name
            )}
          </Breadcrumb.Item>
        );
      })}
    </Breadcrumb>
  );
};
